import { render, staticRenderFns } from "./FormResultsList.vue?vue&type=template&id=40f00c31"
import script from "./FormResultsList.vue?vue&type=script&lang=js"
export * from "./FormResultsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f00c31')) {
      api.createRecord('40f00c31', component.options)
    } else {
      api.reload('40f00c31', component.options)
    }
    module.hot.accept("./FormResultsList.vue?vue&type=template&id=40f00c31", function () {
      api.rerender('40f00c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormResultsList.vue"
export default component.exports